import React from 'react';
import { CampaignCard } from '@lux/campaign-card';
import { BrandColor, FunctionColor, Preset, Text } from '@lux/text';
import { Translate, TranslateScope } from '@pegasus/translation';
import { FormatPrice } from '@browsing/components';
import debounce from 'lodash/debounce';
import { InView } from 'react-intersection-observer';
import { tracker } from '@browsing/tracking';
import TimeLeft from './time-left';
import * as S from './styles';
import { showstopperTracker } from './tracking';
export var Carousel = function (_a) {
    var showStopperPosition = _a.showStopperPosition, categoryTabId = _a.categoryTabId, visitorID = _a.visitorID, isMobileScreen = _a.isMobileScreen, carouselItems = _a.carouselItems;
    var handleScroll = debounce(function () {
        showstopperTracker.track('getInspired_multiCampaign_scroll', {
            isGetInspired: '1',
            getInspiredLength: carouselItems.length,
        });
    }, 100);
    var handleClick = function (brand, articleUrl, productCampaign, positionNumber, isEarlyAccess) {
        var position = "".concat(showStopperPosition, "|").concat(positionNumber);
        tracker.track('campaignOverview_campaign_click', {
            productCampaign: productCampaign,
            positionNumber: position,
            campaign_level_1: brand,
            campaign_level_2: categoryTabId,
            visitorID: visitorID,
            isGetInspired: '1',
            isEarlyAccess: isEarlyAccess ? '1' : '0',
        });
        showstopperTracker.track('getInspired_multiCampaign_click', {
            isGetInspired: '1',
            getInspiredLength: carouselItems.length,
            productCampaign: productCampaign,
            positionNumber: positionNumber,
        });
    };
    var onInViewChange = function (isInView, productCampaign, positionNumber) {
        if (isInView) {
            showstopperTracker.track('getInspired_multiCampaign_impression', {
                isGetInspired: '1',
                getInspiredLength: carouselItems.length,
                productCampaign: productCampaign,
                positionNumber: positionNumber,
            });
        }
    };
    return (React.createElement(TranslateScope, { path: "myLounge" },
        React.createElement(S.ResponsiveCarouselWrapper, { visibleItems: 2, visibleItemsXs: 3, visibleItemsSm: 3, visibleItemsLg: 4, onScroll: handleScroll, singleStep: true, carouselLabel: "Carousel", previousSlideLabel: "previous", nextSlideLabel: "next" }, carouselItems.map(function (article, index) { return (React.createElement(InView, { as: "div", key: index, onChange: function (inView) { return onInViewChange(inView, article.sku, index); }, triggerOnce: true },
            React.createElement("a", { id: "open-".concat(article.sku, "-isGetInspired"), href: "".concat(article.url, "?is-get-inspired=true") },
                React.createElement(CampaignCard, { onClick: function () {
                        return handleClick(article.brand, article.url, article.sku, index, article.isEarlyAccess);
                    }, image: article.images, name: article.brand, imageAspectRatio: 1.0, hover: true },
                    React.createElement(S.CampaignCardDescription, null,
                        React.createElement(S.OverflowContainer, null,
                            React.createElement(Text, { preset: Preset.S }, article.brand)),
                        React.createElement(Text, { preset: Preset.XS }, article.commodityGroup),
                        article.discount && (React.createElement(S.StyledKicker, { title: React.createElement(Translate, { message: "campaigns.upTo" }), titlePreset: Preset.XS },
                            React.createElement(S.KickerText, { preset: Preset.XS, bold: true },
                                article.discount,
                                "%"))),
                        article.price && (React.createElement("div", null,
                            React.createElement(Text, { preset: Preset.XS, color: FunctionColor.function60 },
                                React.createElement(Translate, { message: "recommendations.regularPriceShort" }),
                                ' ',
                                React.createElement(FormatPrice, { price: article.price, superscript: "*" })),
                            React.createElement("div", null,
                                React.createElement(Text, { preset: Preset.S, bold: true, color: BrandColor.primary },
                                    React.createElement(FormatPrice, { price: article.specialPrice }))))),
                        article.dateTill && React.createElement(TimeLeft, { dateTill: article.dateTill })))))); }))));
};
